module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I would like to start by thanking the many people who took time to share their experiences and stories with me. This book would not be possible without them. Others I would like to thank include the following:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My parents, Shooter and Diana Pope. They gave me everything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My lovely wife, Hope Nelson. She has the patience of a saint, the killer instincts of a skillful copy editor and a heart of gold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wellington Watts, owner of Alexandria Colonial Tours. His guidance and friendship have been invaluable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ken Balbuena, tour guide and friend. His research skills and storytelling skills are second to none.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Louise Krafft, the best damn photographer in Virginia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George Combs, director of the Alexandria Library’s Special Collections. He knows where all the bodies are buried.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5abd810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgement.vue
// module id = 69
// module chunks = 0